import React from 'react';
import '../../App.css';
import HeroSection from '../HeroSection';
import Cards from '../Cards';
import ImageSlider from '../BasicSlider/BasicSlider';
import Code from '../Code';

function Home(){
    return (
        <>
            <HeroSection/>
            <Cards/>
            <ImageSlider/>
            <Code/>
         
        </>
    )
}

export default Home;